import { useCallback } from 'react'
import type { Snackbar } from 'settle-ui/hooks/useSnackbarsStore/useSnackbarsStore.types'
import { logEvent } from 'lib/tracking/segment'
import { getSnackbarLocation, type GetSnackbarLocationProps } from './helpers/getSnackbarLocation/getSnackbarLocation'

export const useLogSnackbarEvent = ({ pathname, query, asPath }: GetSnackbarLocationProps, event: string) =>
  useCallback(
    ({ id, variant, message, options }: Snackbar) => {
      const locationGroup = getSnackbarLocation({ pathname, query, asPath })
      const actions = [options?.text].concat(options?.buttons?.map((button) => button?.text)).filter(Boolean)
      const hasActions = actions.length > 0

      return logEvent(event, {
        id,
        variant,
        message,
        actions,
        hasActions,
        locationGroup,
      })
    },
    [pathname, query, asPath, event],
  )
